"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_i18next_1 = require("react-i18next");
const moment_1 = __importDefault(require("moment"));
const svgs_1 = require("@@/assets/svgs");
const components_1 = require("@/common/components");
const functions_1 = require("@/common/functions");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const ToggleButton_1 = __importDefault(require("@mui/material/ToggleButton"));
const Collapse_1 = __importDefault(require("@mui/material/Collapse"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const second_step_1 = require("@/room/room_create/second_step");
const _1 = require(".");
function default_1() {
    const isEdit = (0, react_redux_1.useSelector)((state) => state.isEdit);
    const isCloneRoom = (0, react_redux_1.useSelector)((state) => Boolean(state.roomData.original_room));
    const roomId = (0, react_redux_1.useSelector)((state) => state.roomData.id);
    const productDataFetched = (0, react_redux_1.useSelector)((state) => state.productDataFetched);
    const roomType = (0, react_redux_1.useSelector)((state) => state.roomData.room_type);
    const isFeeFree = (0, react_redux_1.useSelector)((state) => state.roomData.fee_free);
    const isRegularForm = roomType === '굿즈' || roomType === '서포트';
    const isPayForm = isRegularForm && !isFeeFree;
    const isPromiseForm = isRegularForm && isFeeFree;
    const isDemandSurvey = (0, react_redux_1.useSelector)((state) => state.isDemandSurvey);
    const regTime = (0, react_redux_1.useSelector)((state) => state.roomData.regTime);
    const regDate = (0, moment_1.default)(regTime).format('YYYYMMDD');
    const promiseDate = 20220728;
    // ! 무료폼(isFreeFormData): 20220728 약속폼 업데이트 이전에 있었던 유형
    const isFreeFormData = isFeeFree && Number(regDate) - promiseDate <= 0;
    const promiseEditCheck = (0, react_1.useRef)(false);
    const dispatch = (0, react_redux_1.useDispatch)();
    const addNewProduct = () => dispatch((0, roomCreateStore_1.initProduct)(roomId));
    (0, react_1.useEffect)(() => {
        if (roomId && !productDataFetched) {
            if (isEdit || isCloneRoom) {
                dispatch((0, roomCreateStore_1.getProductsData)(roomId));
                if (!isFreeFormData)
                    promiseEditCheck.current = true;
            }
            else {
                addNewProduct();
                promiseEditCheck.current = true;
            }
        }
    }, [roomId]);
    const checkPromiseEditModal = () => {
        if (!promiseEditCheck.current) {
            dispatch((0, roomCreateStore_1.setOpenPromiseEditModal)(true));
            promiseEditCheck.current = true;
        }
    };
    const [openModal, setOpenModal] = (0, react_1.useState)(false);
    const PromiseModalOpenButton = () => ((0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ sx: {
            columnGap: '4px',
            height: '28px',
            padding: '0 12px',
            borderRadius: '100px',
            border: 0,
            bgcolor: 'var(--surface-bg) !important',
            color: 'var(--gray-80)',
            '&.Mui-selected': { color: 'var(--primary-dark)' },
        }, onClick: () => {
            isEdit ? dispatch((0, roomCreateStore_1.setOpenPromiseEditModal)(true)) : setOpenModal(true);
        } }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "caption1" }, { children: t('수수료 자동계산') })), (0, jsx_runtime_1.jsx)(svgs_1.InfoIconBlackSvg, { css: { path: { fillOpacity: 0.3 } } })] })));
    const { t } = (0, react_i18next_1.useTranslation)();
    const productData = (0, react_redux_1.useSelector)((state) => state.productData);
    const isProductAddable = !isDemandSurvey || (isDemandSurvey && productData.length < 50);
    const onAddProductClick = () => {
        if (isProductAddable) {
            checkPromiseEditModal();
            addNewProduct();
        }
        else
            (0, functions_1.showToastMessage)({ message: t('최대 50개까지 추가할 수 있어요') });
    };
    const [expand, setExpand] = (0, react_1.useState)(true);
    const ProductListFoldButton = () => ((0, jsx_runtime_1.jsx)(ToggleButton_1.default, Object.assign({ value: "fold", sx: {
            height: '28px',
            border: '0',
            borderRadius: '100px',
            bgcolor: 'var(--surface-bg) !important',
            color: 'var(--primary-dark)',
            '&.Mui-selected': {
                color: 'var(--gray-80)',
            },
        }, selected: expand, onChange: () => setExpand(!expand) }, { children: expand ? ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "caption1" }, { children: t('접기') }))) : ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "caption1" }, { children: t('펼치기') }))) })));
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    // ? Collapse 컴포넌트 사용 -> 부모엘리먼트 패딩 사용 불가 (MidSectionWrapper 사용 불가)
    // ! Collapse 컴포넌트 자체에 패딩 줘야 함
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "surface-white", css: {
                    display: maxWidth768 ? 'flex' : 'grid',
                    flexDirection: 'column',
                    gridTemplateColumns: '240px auto',
                    borderBottom: '1px solid var(--gray-5)',
                    marginBottom: maxWidth768 ? '10px' : 0,
                } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            padding: `${maxWidth768 ? '20' : '28'}px 16px 0`,
                        } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "subtitle2", css: { display: 'flex', columnGap: '2px' } }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "gray-80" }, { children: t('작품 메뉴') })), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "error-main" }, { children: "*" }))] })), maxWidth768 && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', columnGap: '10px' } }, { children: [isPromiseForm && (0, jsx_runtime_1.jsx)(PromiseModalOpenButton, {}), isPayForm && (0, jsx_runtime_1.jsx)(components_1.AutoFeeTooltip, {}), (0, jsx_runtime_1.jsx)(ProductListFoldButton, {})] })))] })), (0, jsx_runtime_1.jsxs)("div", { children: [!maxWidth768 && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    columnGap: '10px',
                                    padding: '28px 16px 0',
                                } }, { children: [isPromiseForm && (0, jsx_runtime_1.jsx)(PromiseModalOpenButton, {}), isPayForm && (0, jsx_runtime_1.jsx)(components_1.AutoFeeTooltip, {}), (0, jsx_runtime_1.jsx)(ProductListFoldButton, {})] }))), (0, jsx_runtime_1.jsxs)(Collapse_1.default, Object.assign({ in: expand, timeout: 150, sx: { padding: `0 16px ${maxWidth768 ? '20' : '28'}px ` } }, { children: [productData.map((product, idx) => ((0, jsx_runtime_1.jsx)(_1.Product, { product: product, productIndex: idx }, `product_${product.id}_${idx}`))), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ sx: {
                                            float: 'right',
                                            height: '32px',
                                            padding: '0 12px',
                                            borderRadius: '6px',
                                            border: '1px solid var(--gray-80)',
                                            mt: '20px',
                                            bgcolor: 'var(--white) !important',
                                            color: 'var(--gray-80)',
                                        }, onClick: onAddProductClick }, { children: (0, jsx_runtime_1.jsxs)("span", Object.assign({ className: "subtitle4" }, { children: ["+ ", t('메뉴 추가')] })) }))] }))] })] })), isEdit ? ((0, jsx_runtime_1.jsx)(_1.PromiseEditModal, {})) : ((0, jsx_runtime_1.jsx)(second_step_1.PromiseModal, { openModal: openModal, setOpenModal: setOpenModal }))] }));
}
exports.default = default_1;
